import ModalTransDetails from "../modals/ModalTransDetails";
import ModalEditTransFactorNum from "../modals/ModalEditTransFactorNum";
import ModalRejectFactor from "../modals/ModalRejectFactor";

const ImportModals = () => {
    return (
        <div id={'base-box-all-modals'}>
            <ModalTransDetails />
            <ModalEditTransFactorNum />
            <ModalRejectFactor />
        </div>
    );
}

export default ImportModals;
